import { toast } from 'react-toastify';
import axiosInstance from '../../../../../axiosInstance';
import { getDomain, getEmployeeId, getUserId } from '../../../Base/helper/baseFunctions';
import { HRMS_LMS_API_URL } from '../../../../Constants/baseConstant';


export const GetMyAttendanceRegularizationHelper = async (params) => {
    return await axiosInstance(`/lms/regularization/getMyAttendanceRegularization`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: getDomain(),
            employee_fk: getEmployeeId(),
            month: params.month,
            year: params.year,
            tab: params?.tab // 'Team' or 'Self'
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const UpsertMyAttendanceRegularizationHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    const successMessage = params?.actionType === "add" ? "Regularization added successfully" : "Regularization updated successfully" 
    return await axiosInstance(`/lms/regularization/upsertMyAttendanceRegularization`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: getDomain(),
            employee_fk: params?.employee_fk,
            month: params.month || null,
            year: params.year || null,
            user_id: getUserId(),
            in_date: params?.in_date,
            out_date: params?.out_date,
            in_time: params?.in_time,
            out_time: params?.out_time,
            attendance_regularisation_pk: params?.attendance_regularisation_pk || null,
            tab: params?.tab,
            status: params?.status
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success(successMessage);
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message || "Error");
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const DeleteMyAttendanceRegularizationHelper = async (params) => {
    toast.info("Deleting...");
    return await axiosInstance(`/lms/regularization/deleteMyAttendanceRegularization`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: getDomain(),
            attendance_regularisation_pk: params?.attendance_regularisation_pk,
            month: params.month,
            year: params.year,
            tab: params?.tab,
            logged_in_employee_fk: params?.logged_in_employee_fk
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Successfully deleted");
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message || "Error");
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}
// nee to change
export const GetApproverEmpRegularizationMappingHelper = async (params) => {
    return await axiosInstance(`/lms/regularization/getApproverEmpRegularizationMapping`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: getDomain(),
            emp_user_id: getUserId(),
            month: params?.month || null,
            year: params?.year || null,
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const UpdateApproverEmpRegularizationMappingHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/lms/regularization/updateApproverEmpRegularizationMapping`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: getDomain(),
            attendance_regularisation_pk: params.attendance_regularisation_pk,
            user_id: getUserId(),
            employee_fk: params?.employee_fk,
            status: params.status, // Approved / Rejected
            comment: params?.comment || null,
            year: null,
            month: null,

        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Regularization updated successfully");
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message || "Error");
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}


export const GetAutofillAttendanceRegularizationHelper = async (params) => {
    return await axiosInstance(`/lms/regularization/getAutofillAttendanceRegularization`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: getDomain(),
            employee_fk: params?.employee_fk,
            date: params?.date
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

